import React from 'react';
import { Modal, Form, Select, Input, Button } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

const ManualResolveModal = ({ visible, onCancel, onResolve, loading }) => {
    const [form] = Form.useForm();

    const handleOk = () => {
        form.validateFields().then((values) => {
            onResolve(values);
        });
    };

    return (
        <Modal
            title="Manual Resolve Transaction"
            visible={visible}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={loading}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Resolve
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="status"
                    label="Status"
                    rules={[{ required: true, message: 'Please select a status' }]}
                >
                    <Select placeholder="Select Status">
                        <Option value="SUCCESS">SUCCESS</Option>
                        <Option value="REVERSED">REVERSAL</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name="comment"
                    label="Comment"
                    rules={[{ required: true, message: 'Please provide a comment' }]}
                >
                    <TextArea rows={4} placeholder="Reason for manual resolution" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ManualResolveModal;
